import type { FC, ReactNode } from 'react';

import { Box } from '@packages/shared/src/components/Box';
import { Button } from '@packages/shared/src/components/Button';

export type FilterSettingsMobileButtonProps = {
  children: ReactNode;
  onClick?: () => void;
};

export const FilterSettingsMobileButton: FC<FilterSettingsMobileButtonProps> = ({
  children,
  onClick,
}) => (
  <Button
    sx={{
      flex: 1,
      height: '1.5rem',
      '& svg': {
        height: '2rem',
        width: '2rem',
      },
    }}
    endIcon={<span className="icon-emp-arrow-medium-down size-4" />}
    onClick={onClick}
  >
    <Box
      sx={{
        width: '100%',
        marginRight: 'auto',
        overflow: 'hidden',
        textAlign: 'left',
      }}
    >
      {children}
    </Box>
  </Button>
);
